module.exports = "{{buttonText}}";